import { useRecoilValue } from "recoil";
import organizationDataState from "../atoms/organizationDataAtom";

const ML_PER_OZ = 29.5735;

/**
 * Returns helpers for displaying water values in the org's preferred unit.
 * Water is always stored in Firestore as ml; conversion is display-only.
 */
const useWaterUnit = () => {
  const orgData = useRecoilValue(organizationDataState);
  const isImperial = orgData?.unitSystem === "imperial";
  const unit = isImperial ? "oz" : "ml";

  /**
   * Format a stored ml value for display → { value: number, unit: string }
   */
  const formatWater = (ml) => {
    if (isImperial) {
      return { value: Math.round((ml / ML_PER_OZ) * 10) / 10, unit: "oz" };
    }
    return { value: Math.round(ml || 0), unit: "ml" };
  };

  /**
   * Short label string, e.g. "500 ml" or "16.9 oz"
   */
  const waterLabel = (ml) => {
    const { value, unit: u } = formatWater(ml);
    return `${value} ${u}`;
  };

  return { formatWater, waterLabel, unit, isImperial };
};

export default useWaterUnit;
